export const createFlow = 'createFlow';
export const updateFlow = 'updateFlow';

export const createFlowAccess = 'createFlowAccess';
export const updateFlowAccess = 'updateFlowAccess';
